// extracted by mini-css-extract-plugin
export default {"sectionDivider":"SectionDividerWithNoLine_sectionDivider__N5o3-","text":"SectionDividerWithNoLine_text__MgcKk"};